'use strict';

function resizeWindow() {
	var leftside = ($(window).width() - $('header .container').width()) / 2;
	$('.black-back').css('left', leftside);

	//Tablet and mobile nav
	if ($(window).width() < 1090) {
		//Toggle open/close on tap
		$('#primary-nav li a').click(function (e) {

			if ($(this).next('.submenu').length > 0) {
				e.preventDefault();
				$('#primary-nav ul li').removeClass('item-open');
				$(this).parent().addClass('item-open');

				if (!$(this).next('.submenu').hasClass('menu-open')) {
					$('.submenu.menu-open').slideUp(300, 'easeOutQuart').removeClass('menu-open');
				}
				$(this).next().addClass('menu-open').slideDown(300, 'easeOutQuart');
			}
		});
	} else {
		// Main Nav Dropdown
		$("#primary-nav li").hover(function () {
			$(this).addClass("hover");
			$('ul.submenu', this).fadeIn(200);
		}, function () {
			$(this).removeClass("hover");
			$('ul.submenu', this).fadeOut(200);
		});
	}
}
function scrollDown() {
	var top = $(document).scrollTop();
	if (top > 50) {
		$('#home header').addClass('down');
		$('#home .black-back').addClass('down');
	} else {
		$('#home header').removeClass('down');
		$('#home .black-back').removeClass('down');
	}
}

$(document).ready(function () {

	if (!$('#home').length > 0) {
		$('header').addClass('fixed');
		$('.black-back').addClass('fixed');
	}

	//Contact form without image and links
	$('.contact-detail .form_contact img, .contact-detail .form_contact .links').remove();

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});

	//Acts when scroll down page.
	$(window).scroll(function (event) {
		scrollDown();
	});

	setTimeout(function () {
		$('header .pull-right').addClass('shown');
		$('#home .arrow-home').addClass('shown');
	}, 500);

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() * 2 }, 800, 'easeOutExpo');
	});

	//Event Tracking
	$('.book-now').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
	});
	$('.bookNow').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
	});

	$('#header .bars').click(showMenu);

	//Check in and check out datepicker for booking engine
	$("#CheckIn").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut").datepicker("setDate", newDate);
			$("#CheckOut").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn").datepicker("option", "maxDate", selectedDate);
		}
	});

	$('form .btn.btnSubmit').click(function () {
		setTimeout(function () {
			$('p#thankyou').fadeOut(500);
		}, 6000);
	});

	// Map: Return to previous page button. Change body id to match map template's name.
	//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	// remove attributes 
	$('#third-nav').removeAttr('aria-labelledby');
	$('#third-nav').removeAttr('aria-label');
	$('#primary-nav').removeAttr('aria-label');
});

$(window).on('load', function () {
	resizeWindow();
	scrollDown();
	//Slick Slider
	$('.sym-slides').slick();
});

function showMenu() {
	$(this).addClass('open');
	$('.black-back').addClass('openMenu');
	var pheight = $(window).height() - 115;
	if (!$('#header #primary-nav').hasClass('mobile')) {
		$('#header #primary-nav').wrapInner('<div class="wrap"></div>');
		$('#header #primary-nav').insertAfter('#header .pull-right');
		$('#header #primary-nav').addClass('mobile');
	}
	$('#header #primary-nav').height(pheight);
	setTimeout(function () {
		$('#header #primary-nav').fadeIn();
	}, 600);
	$(this).unbind('click');
	$(this).click(hideMenu);
}
function hideMenu() {
	$(this).removeClass('open');

	if ($(window).width() > 800) {
		$('#header #primary-nav').insertAfter('.pull-right .phone');
	}
	$('#header #primary-nav').fadeOut(400);
	setTimeout(function () {
		$('.black-back').removeClass('openMenu');
	}, 300);
	$(this).unbind('click');
	$(this).click(showMenu);
}